/**
 * Runtime config. The API base points at the `api` Cloud Function that serves
 * the tRPC share router. Overridable per environment via VITE_API_BASE_URL;
 * defaults to the local Firebase functions emulator for dev.
 */
const DEFAULT_LOCAL_API = 'http://127.0.0.1:5001/stella-develop/us-west2/api'

export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '') ?? DEFAULT_LOCAL_API
